module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10220.58bf5b26.jpg";